function cqData() {
  return {
    brand: '',
    frame: '',
    productFamily: '',
    productShape: '',
    activityBtns: [],
    weatherBtns: [],
    q1: {},
    q2: {},
    quizMain: {},
    resultsMain: {},
    results: [],
    backBtn: {},
    resetBtn: {},
    activity: '',
    weather: '',
    pick1Polarized: true,
    pick2Polarized: true,
    currentOption1: '',
    currentOption1_id: '',
    url1: '',
    url2: '',
    polarization1: '',
    polarization2: '',
    color1: '',
    color2: '',
    mainHdr: '',
    emailWrap: {},
    email: '',
    subscribe: false,
    sent: false,
    errorMessage: null,
    no_quiz_reset: false,
    quizCompleted: false,


    setColors: function (e) {
      // this is probably going away
      console.log('set color source:', e.target)
      const currentRadioBtn = e.target;
      console.log('currentRadioBtn:', currentRadioBtn)

    },

    chooseActivity: function () {
      console.log('click!!! from chooseActivity', this.activity);
      this.q1.classList.add('off-left');
      setTimeout(() => {
        this.q1.classList.add('quiz-hide');
        this.q2.classList.remove('quiz-hide');
        this.q2.classList.remove('off-right');
        this.q2.classList.add('current');
        this.quizMain.classList.remove('cq-step-1');
        this.quizMain.classList.add('cq-step-2');
        this.backBtn.style.display = 'block';
      }, 100);
    },

    displayResults: function () {
      const resultsWrap = document.querySelector('.cq-result-scroll');
      if (!resultsWrap) {
        console.log('no results container!');
        return false;
      }

      this.mainHdr = "Your Results";
      console.log('updating quiz header')

      const currentActivityInput = document.querySelector('input[name="cq-question-activity"]:checked');
      const nextLabel = currentActivityInput.nextElementSibling;
      const currentActivity = nextLabel.textContent.toLowerCase();

      if (this.results.length > 0) {
        /* let theBrand = this.results[0].node.tags.find((tag) => tag.includes('brand:'));
        if (theBrand) {
          theBrand = theBrand.replace('brand:', '');
        } else {
          theBrand = '';
        }
        this.brand = theBrand; */
        this.brand = mainProduct.brand || '';

        /* const theFrame = this.results[0].node.tags.find((tag) => tag.includes('frame:'));
        if (theFrame) {
          this.frame = theFrame.replace('frame:', '');
        } */
        this.frame = mainProduct.frame || '';

        /* const theProductFamily = this.results[0].node.tags.find((tag) => tag.includes('product-family:'));
        if (theProductFamily) {
          this.productFamily = theProductFamily.replace('product-family:', '');
        } */
        this.productFamily = mainProduct.productFamily || '';

        /* const theShape = this.results[0].node.tags.find((tag) => tag.startsWith('shape:'));
        if (theShape) {
          this.productShape = theShape.replace('shape:', '').replace('Standard', ' ');
        } */
        this.productShape = mainProduct.shape || '';

        let productFamilyHTML = '';
        if (this.productFamily && this.productShape) {
          productFamilyHTML = `${this.productFamily} <span class="cq-product-shape">${this.productShape}</span>`;
        } else {
          productFamilyHTML = `${this.brand} ${this.frame}`;
        }

        resultsWrap.innerHTML = this.results.map((item, i) => {
          if (i > 1) {
            return;
          }
          console.log('index:::', i);
          console.log('item:::', item);
          console.log('item.metafields.image_gallery:::', item.metafields.image_gallery);
          let img = item.metafields.image_gallery[0];

          const imgAlt = item.title;
          let hdr;

          /* const variantTitleSplit = item.title.split('/');
          this.currentOption1 = variantTitleSplit[0].trim(); */
          this.currentOption1 = item.option1;
          this.currentOption1_id = item.id;

          /* const lensTier = item.node.tags.filter(str => str.includes('lens-tier:')); */
          const polarization = item.option2;

          if (i === 0) {
            hdr = 'The Top Pick';
            this.url1 = `${window.location.protocol}/${window.location.host}/${item.url}`;
            this.polarization1 = polarization;
            this.color1 = this.currentOption1;
          } else {
            hdr = 'Another Great Option';
            this.url2 = `${window.location.protocol}/${window.location.host}/${item.url}`;
            this.polarization2 = polarization;
            this.color2 = this.currentOption1;
          }
          console.log('checking url1:', this.url1);
          console.log('checking url2:', this.url2);


          // need to get rid of the null values
          /* const reducedMetafields = item.metafields.filter((el) => el !== null);
          const colorDescriptionItem = reducedMetafields.find((el) => {
            return el.key === 'quiz_color_description';
          }); 
          console.log('colorDescriptionItem', colorDescriptionItem);
          */

          /* let colorDescription;
          if (colorDescriptionItem) {
            colorDescription = colorDescriptionItem.value;
          } */
          let colorDescription = item.metafields.quiz_color_description;
          console.log('colorDescription', colorDescription);

          let lightHTML = '';
          if (this.weather === 'quiz-condition:sunny') {
            lightHTML = `<div class="cq-result-icon-wrap">
              <div class="cq-result-icon">
              <img src="https://cdn.shopify.com/s/files/1/0260/5816/2253/files/icon-sunshine.svg?v=1690505995" alt="" aria-hidden="true" focusable="false" role="presentation" class="icon-sunshine">
              </div>
              <div class="cq-result-text">Best for bright light</div>
            </div>`;
          } else if (this.weather === 'quiz-condition:mixed') {
            lightHTML = `<div class="cq-result-icon-wrap">
              <div class="cq-result-icon">
              <img src="https://cdn.shopify.com/s/files/1/0260/5816/2253/files/icon-sunny-cloudy.svg?v=1690505995" alt="" aria-hidden="true" focusable="false" role="presentation" class="icon-sunshine">
              </div>
              <div class="cq-result-text">Best for mixed light</div>
            </div>`;
          } else if (this.weather === 'quiz-condition:cloudy') {
            lightHTML = `<div class="cq-result-icon-wrap">
              <div class="cq-result-icon">
              <img src="https://cdn.shopify.com/s/files/1/0260/5816/2253/files/icon-cloudy.svg?v=1690926296" alt="" aria-hidden="true" focusable="false" role="presentation" class="icon-sunshine">
              </div>
              <div class="cq-result-text">Best for low light</div>
            </div>`;
          }

          let polarizationHTML = '';
          if (polarization.toLowerCase().includes('non')) {
            polarizationHTML = '';
          } else if (polarization.toLowerCase().includes('elite')) {
            polarizationHTML = `<div class="cq-result-icon-wrap icon-polarization-wrap">
              <div class="cq-result-icon">
              <img src="https://cdn.shopify.com/s/files/1/0260/5816/2253/files/icon-polarization.svg?v=1690505995" alt="" aria-hidden="true" focusable="false" role="presentation" class="icon-polarization">
              </div>
              <div class="cq-result-text">Polarized lenses increase the contrast in your environment by removing distracting light making it perfect for ${currentActivity}.</div>
            </div>`;
          } else {
            polarizationHTML = `<div class="cq-result-icon-wrap icon-polarization-wrap">
              <div class="cq-result-icon">
              <img src="https://cdn.shopify.com/s/files/1/0260/5816/2253/files/icon-polarization.svg?v=1690505995" alt="" aria-hidden="true" focusable="false" role="presentation" class="icon-polarization">
              </div>
              <div class="cq-result-text">Polarized lenses increase the contrast in your environment by removing distracting light making it perfect for ${currentActivity}.</div>
            </div>`;
          }

          return `<div class="cq-result cq-result-1 newway">
          <hr class="hr-cq hr-cq-${i}">
            <div class="cq-result-wrap">
              <div class="cq-result-img-title">
                <div class="cq-result-img">
                  <img src="${img}" alt="${imgAlt}">
                </div>
                <div class="cq-result-title">
                  <h3>${hdr}</h3>
    
                  <div class="cq-result-details">
                    <h6 class="bold">${polarization}</h6>
                    <h6 class="bold">${this.currentOption1}</h6>
                    <h6 class="bold">For: <span style="font-weight: normal; font-size: 85%;">${productFamilyHTML}</span></h6>
                  </div>
                  
                  <button class="button button--primary button--block cq-button" data-cq_color_option="${this.currentOption1}" data-cq_variant_id="${this.currentOption1_id}" data-cq_polar_option="${polarization}">Choose This Color</button>
                </div>
              </div>
    
              <div class="cq-result-icons">
                <div class="cq-result-icon-wrap">
                  <div class="cq-result-icon">
                    <img src="https://cdn.shopify.com/s/files/1/0260/5816/2253/files/icon-water-glare.svg?v=1690505995" alt="" aria-hidden="true" focusable="false" role="presentation" class="icon-water-glare">
                  </div>
    
                  <div class="cq-result-text">${colorDescription}</div>
                </div>
                
                ${lightHTML}
                
                ${polarizationHTML}
              </div>
            </div>
            
          </div>`;
        }).join('');
      }

      console.log('this.results.length', this.results.length);
      console.log('this.results', this.results);

      if (this.results.length === 0) {
        resultsWrap.innerHTML = `<p class="no-results">Hmm, no results?! We're stumped.</p>`
      }

      this.emailWrap.style.display = 'block';
    },

    getResults: function () {
      // these variables (dataReturnNonMirrored and dataReturnMirrored) declared in product.replacement-lenses.liquid
      // and the get values in ReplacementMin.js
      // const dataReturnAll = dataReturnMirrored.concat(dataReturnNonMirrored);
      // console.log('dataReturnAll', dataReturnAll)
      // now using mainProduct!!!!!!

      console.log('this.activity', this.activity)
      console.log('this.weather', this.weather)
      let filteredReturns = mainProduct.variants.filter((el) => {
        let hasActivity = false;
        let hasWeather = false;
        if (el.metafields.quiz_activity_list.includes(this.activity.replace('quiz-activity:', ''))) {
          hasActivity = true;
        }
        if (el.metafields.quiz_condition_list.includes(this.weather.replace('quiz-condition:', ''))) {
          hasWeather = true;
        }
        return hasActivity && hasWeather;
      });

      console.log('filteredReturns', filteredReturns)

      /* 
      Sunny: Stealth Black - Polarized
      Mixed: Emerald Green - Polarized
      Low: Crystal Clear - Non-Polarized 
      */
      if (filteredReturns.length === 0) {
        console.log('looking for results')
        if (this.weather.includes('sunny')) {
          console.log('we have sunny weather')
          filteredReturns = mainProduct.variants.filter((el) => {
            let hasType = false;
            let hasColor = false;
            if (el.option2 === 'Polarized') {
              console.log('hasType Polarized for sunny weather')
              hasType = true;
            }
            if (el.option1.includes('Stealth Black')) {
              console.log('hasColor Stealth Black for sunny weather')
              hasColor = true;
            }
            return hasType && hasColor;
          });
        }
        if (this.weather.includes('mixed')) {
          console.log('we have mixed weather')
          filteredReturns = mainProduct.variants.filter((el) => {
            let hasType = false;
            let hasColor = false;
            if (el.option2.includes('Polarized')) {
              console.log('hasType Polarized for mixed weather')
              hasType = true;
            }
            if (el.option1.includes('Emerald Green MirrorShield®')) {
              console.log('hasColor Emerald Green for mixed weather')
              hasColor = true;
            }
            return hasType && hasColor;
          });
        }
        if (this.weather.includes('cloudy')) {
          console.log('we have cloudy weather')
          filteredReturns = mainProduct.variants.filter((el) => {
            let hasType = false;
            let hasColor = false;
            if (el.option2.includes('Non-Polarized')) {
              console.log('hasType Non-Polarized for cloudy weather')
              hasType = true;
            }
            if (el.option1.includes('Crystal Clear')) {
              console.log('hasColor Crystal Clear for weather')
              hasColor = true;
            }
            return hasType && hasColor;
          });
        }
      }

      // limit it to 2 items
      if (filteredReturns.length > 0) {
        filteredReturns.length = 2;
      }
      console.log('filteredReturns 2!', filteredReturns)

      this.quizCompleted = true;
      this.results = filteredReturns;
      this.displayResults();

    },

    chooseWeather: function () {
      console.log('click!!! from chooseWeather', this.weather);
      this.resetBtn.style.display = 'block';
      this.backBtn.style.display = 'none';
      this.quizMain.classList.add('off-left');
      setTimeout(() => {
        this.quizMain.classList.add('quiz-hide');
        this.q2.classList.remove('current');
        this.resultsMain.classList.remove('quiz-hide');
        this.resultsMain.classList.remove('off-right');
        this.resultsMain.classList.add('current');
        // this.mainHdr = document.querySelector('[data-main_hdr]').dataset.main_hdr;
      }, 100);

      console.log('the weather: ', this.weather)

      this.getResults();

    },

    resetQuiz: function () {
      // console.log('reset!!!');
      console.log('this.resultsMain in reset', this.resultsMain)
      this.resultsMain.classList.remove('current');
      this.resultsMain.classList.add('off-right');
      setTimeout(() => {
        this.resultsMain.classList.add('quiz-hide');
        this.resetBtn.style.display = 'none';
        this.quizMain.classList.remove('quiz-hide');
        this.quizMain.classList.remove('off-left');
        this.quizMain.classList.remove('cq-step-2');
        this.quizMain.classList.add('cq-step-1');
        this.q2.classList.remove('quiz-hide');
        this.q2.classList.remove('off-left');
        this.q2.classList.add('quiz-hide');
        this.q2.classList.add('off-right');
        this.q1.classList.remove('off-left');
        this.q1.classList.remove('quiz-hide');
        this.sent = false;
        this.errorMessage = '';
        this.mainHdr = document.querySelector('[data-main_hdr]').dataset.main_hdr;
      }, 100);

      this.results = [];
      this.quizCompleted = false;

      this.activityBtns.forEach((el) => {
        el.checked = false;
      });
      this.weatherBtns.forEach((el) => {
        el.checked = false;
      });

      this.emailWrap.style.display = 'none';
    },

    stepBack: function () {
      this.q2.classList.remove('current');
      this.q2.classList.add('off-right');
      this.q1.classList.remove('off-left');
      setTimeout(() => {
        this.q1.classList.remove('quiz-hide');
        this.q1.classList.remove('off-left');
        this.quizMain.classList.remove('cq-step-2');
        this.quizMain.classList.add('cq-step-1');
        this.backBtn.style.display = 'none';
      }, 100);

    },

    cqInit: function () {
      // console.log('running cqInit!!!')
      this.quizMain = document.querySelector('.quiz-main');
      this.resultsMain = document.querySelector('.cq-results');
      console.log('this.resultsMain', this.resultsMain)
      this.backBtn = document.querySelector('.step-back');
      this.resetBtn = document.querySelector('.cq-reset');
      console.log('this.resetBtn:', this.resetBtn)
      this.q1 = document.querySelector('.cq-question-1');
      this.q2 = document.querySelector('.cq-question-2');
      this.activityBtns = document.querySelectorAll('[name="cq-question-activity"]');
      this.weatherBtns = document.querySelectorAll('[name="cq-question-weather"]');
      console.log('this.weatherBtns:', this.weatherBtns)
      this.mainHdr = document.querySelector('[data-main_hdr]').dataset.main_hdr;
      this.emailWrap = document.querySelector('.cq-email-results-wrap');

      const that = this;
      this.activityBtns.forEach((el) => el.addEventListener('change', function (e) {
        setTimeout(function () {
          that.setColors(e);
          that.chooseActivity();
        }, 10)

      }));
      this.weatherBtns.forEach(el => el.addEventListener('change', function () {
        setTimeout(function () {
          that.chooseWeather();
        }, 10)
      }));

      const inputVarId = document.querySelector('.product-variant-id')
      if (inputVarId) {
        //console.log('inputVarId changed!')
        inputVarId.addEventListener('change', () => {
          if (this.no_quiz_reset) return;
          this.resetQuiz();
        });
      }

      const tmpBrand = document.querySelector('.breadcrumb-brand');
      if (tmpBrand) {
        this.brand = tmpBrand.querySelector('a').innerText;
      }
      const tmpFrame = document.querySelector('.breadcrumb-frame');
      if (tmpFrame) {
        this.frame = tmpFrame.innerText;
      }

      document.addEventListener('click', (e) => {
        const target = e.target;
        if (!target.matches('.cq-button')) { return; }
        //console.log('target button: ', target);
        that.selectColor(target);
      });
    },

    selectColor: function (button) {
      const closeBtn = document.querySelector('.color-quiz-modal .modal__close-trigger');
      const colorOption = button.dataset.cq_color_option;
      const polarOption = button.dataset.cq_polar_option;
      //console.log('colorOption', colorOption)
      //console.log('polarOption', polarOption)

      const colorChoice = document.querySelector(`[name="Lens Color-1"][value="${colorOption}"]`);
      let lensTypeBtn;

      /* if (polarOption.toLowerCase().includes('non')) {
        lensTypeBtn = document.querySelector(`[name="Lens Type"][value="Non-Polarized"]`);
      } else if (polarOption.toLowerCase().includes('elite')) {
        lensTypeBtn = document.querySelector('.elite-polarized button')
      } else {
        lensTypeBtn = document.querySelector('.polarized button')
      } */


      this.no_quiz_reset = true;
      const lens_type = button.dataset.cq_polar_option;
      document.dispatchEvent(new CustomEvent('color_quiz_selection', { bubbles: true, detail: { lens_type: lens_type } }));
      // console.log('dispatching color_quiz_selection')
      colorChoice.click();
      /* Old - now product-info.js listens for event dispatched above
       setTimeout(() => {
        lensTypeBtn = document.querySelector(`[name="Lens Type-2"][value="${polarOption}"]`);
        console.log('test:', document.querySelector(`[name="Lens Type-2"][value="${polarOption}"]`))
        lensTypeBtn.click();
      }, 100); */
      this.resetNoQuizReset();
      closeBtn.click();
    },

    resetNoQuizReset: function () {
      setTimeout(() => {
        this.no_quiz_reset = false;
      }, 1000);
    },

    /* mainHdrText: function () {
      return this.mainHdr;
    }, */


    sendCQEmail: function (e) {
      this.errorMessage = null;

      if (!/\S+@\S+\.\S+/.test(this.email)) {
        this.errorMessage = 'Invalid Email';
        return;
      }

      /* // convert summary array to an object
      let summary = this.orderSummary.reduce((acc, curr) => {
        acc[curr.key] = curr;
        return acc;
      }, {});  */

      const klaviyoId = window.themeVariables.settings.klaviyoId
      /* const data = {
        token: window.themeVariables.settings.klaviyoId,
        event: "Save Color Quiz Results",
        customer_properties: {
          $email: this.email,
          $consent: "['email']",
        },
        properties: {
          quizActivity: this.activity.replace('quiz-activity:', ''),
          quizCondition: this.weather.replace('quiz-condition:', ''),
          quizItemRecommendations: [],
        }
      } */
      const data2024 = {
        data: {
          type: 'event',
          attributes: {
            metric: { data: { type: 'metric', attributes: { name: 'Save Color Quiz Results' } } },
            properties: {
              quizActivity: this.activity.replace('quiz-activity:', ''),
              quizCondition: this.weather.replace('quiz-condition:', ''),
              quizItemRecommendations: [],
            },
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: this.email
                }
              }
            }
          }
        }
      } // const data2024

      this.results.forEach((el, i) => {
        console.log('going through results, index:', i)
        const recommendedItem = {};
        /* const name = el.title;
        const nameSplit = name.split('|'); */
        recommendedItem.itemSku = el.sku;
        recommendedItem.itemName = mainProduct.title;
        recommendedItem.itemShopifyId = mainProduct.id;
        recommendedItem.itemShopifyVariantId = el.id;
        if (i === 0) {
          recommendedItem.itemURL = this.url1;
          recommendedItem.color = this.color1;
          recommendedItem.polarization = this.polarization1;
        }
        if (i === 1) {
          recommendedItem.itemURL = this.url2;
          recommendedItem.color = this.color2;
          recommendedItem.polarization = this.polarization2;
        }
        recommendedItem.brand = this.brand;
        recommendedItem.frame = this.frame;
        console.log({ recommendedItem })
        //data.properties.quizItemRecommendations.push(recommendedItem)
        data2024.data.attributes.properties.quizItemRecommendations.push(recommendedItem)
      })

      /* data.properties.rec_url1 = this.url1;
      data.properties.color1 = this.color1;
      if (this.results.length > 1) {
        data.properties.rec_url2 = this.url2;
        data.properties.color2 = this.color2;
      } */


      const options2024 = {
        method: 'POST',
        headers: {
          accept: 'application/json',
          revision: '2024-05-15',
          'content-type': 'application/json'
        },
        body: JSON.stringify(data2024)
      }

      /* const d = new FormData();
      d.append('data', JSON.stringify(data));
    
      console.log('data:::', data) */
      console.log('data2024', data2024)

      const promises = [];

      /* const trackPromise = fetch('https://a.klaviyo.com/api/track', {
        body: d,
        method: 'POST',
        referrer: document.URL,
        referrerPolicy: 'strict-origin-when-cross-origin',
        credentials: 'omit',
      })
      promises.push(trackPromise); */

      const trackPromise2024 = fetch(`https://a.klaviyo.com/client/events/?company_id=${klaviyoId}`, options2024);
      promises.push(trackPromise2024);

      if (this.subscribe) {
        /* const listId = window.theme.store.storeCode === "US_dev" ? 
          'NQNRg5' : // dev
          'Js82Pw';  // prod */
        const listId = window.themeVariables.settings.klaviyoColorQuizListId;

        /* const formData = new FormData();
        formData.append('g', listId);
        formData.append('$email', this.email);
        formData.append('$consent', "['email']");
    
        const subscribePromise = fetch('https://a.klaviyo.com/ajax/subscriptions/subscribe', {
          referrer: document.URL,
          referrerPolicy: 'no-referrer-when-downgrade',
          body: formData,
          method: 'POST',
          mode: 'cors',
          credentials: 'omit',
        });
        promises.push(subscribePromise); */

        const optionsSubscribe2024 = {
          method: 'POST',
          headers: { revision: '2024-05-15', 'content-type': 'application/json' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Color quiz optin',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: this.email,
                    }
                  }
                }
              },
              relationships: { list: { data: { type: 'list', id: listId } } }
            }
          })
        };

        const subscribePromise2024 = fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${klaviyoId}`, optionsSubscribe2024);
        promises.push(subscribePromise2024);
      }

      Promise.all(promises).then(() => {
        this.sent = true;
      })
    },

  }
}
